var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isConnected)?_c('v-system-bar',{attrs:{"app":"","dark":"","window":"","color":_vm.color}},[_c('v-spacer'),_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-spacer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }